import { ActionModel } from "../models/actionModel";
import { Dispatch } from "redux";
import { AppActions } from "../types/actions";
import { AppState } from "../reducers/rootReducer";
import formService from "../services/formService";
import { showTotast } from "../components/util/toast";
import produce from "immer";
import { editModal } from "./modalAction";
import {
  addElements,
  editElement,
  removeAllElements,
} from "./elementListAction";
import { editAlert } from "./alertAction";
import { addRows, removeAllRows } from "./rowListAction";
import { addSections, removeAllSections } from "./sectionListAction";
import { addTabs, editTab, removeAllTabs } from "./tabListAction";
import { faBullseye } from "@fortawesome/free-solid-svg-icons";
import { addForm, removeAllForms } from "./formListAction";

export const startApplyRule = (action: ActionModel) => {
  return async (dispatch: Dispatch<AppActions>, getState: () => AppState) => {
    console.log(action.action);
    const appState = getState();
    if (action.renderComponent || action.externalUrl) {
      const { data } = await formService.getFormItemById({
        id: action.renderComponent,
      });
      console.log(data.data);
      switch (action.action) {
        case "show-alert":
          if (data.data.form.alertAttribute)
            showTotast(
              data.data.form.alertAttribute.notificationType,
              data.data.form.alertAttribute.message,
              data.data.form.alertAttribute.position,
              data.data.form.alertAttribute.displayTime,
              data.data.form.alertAttribute.alertTransition
            );
          return;
        case "link-to-modal":
          if (data.data.form) {
            dispatch(addRows(data.data.rowList));
            dispatch(addSections(data.data.sectionList));
            dispatch(addElements(data.data.elementList));
            dispatch(addTabs(data.data.tabList));
            const newModalState = produce(appState.modal, (draft) => {
              draft.show = true;
              draft.id = data.data.form.id;
              draft.name = data.data.form.name;
              draft.properties = data.data.form.modalAttribute;
            });
            dispatch(editModal(newModalState));
          }
          return;
        case "link-to-form":
          if (data.data) {
            dispatch(removeAllForms());
            dispatch(addForm(data.data.form));
            dispatch(removeAllRows([]));
            dispatch(addRows(data.data.rowList));
            dispatch(removeAllSections([]));
            dispatch(addSections(data.data.sectionList));
            dispatch(removeAllElements([]));
            dispatch(addElements(data.data.elementList));
            dispatch(removeAllTabs([]));
            dispatch(addTabs(data.data.tabList));
            const newModalState = produce(appState.modal, (draft) => {
              draft.show = false;
            });
            dispatch(editModal(newModalState));
            const newAlertState = produce(appState.alert, (draft) => {
              draft.id = action.renderComponent;
            });
            dispatch(editAlert(newAlertState));
          }
          return;
        case "show-hide":
          let selectedElement = appState.elementList.present.filter(
            (element) => {
              return element.id === action.renderComponent;
            }
          )[0];
          if (selectedElement) {
            if (
              (selectedElement.type === "tab" ||
                selectedElement.type === "collaps") &&
              !action.entireElemet
            ) {
              let selectedTab = appState.tabList.filter((tab) => {
                return tab.id === action.tabValue;
              })[0];
              if (selectedTab) {
                const newTabeState = produce(selectedTab, (draft) => {
                  draft.display = !draft.display;
                });
                dispatch(editTab(newTabeState));
              }
            } else {
              const newElementState = produce(selectedElement, (draft) => {
                draft.properties.display = !draft.properties.display;
              });
              dispatch(editElement(newElementState));
            }
          }
          return;
        case "show":
          let showElement = appState.elementList.present.filter((element) => {
            return element.id === action.renderComponent;
          })[0];
          if (showElement) {
            if (
              (showElement.type === "tab" || showElement.type === "collaps") &&
              !action.entireElemet
            ) {
              let selectedTab = appState.tabList.filter((tab) => {
                return tab.id === action.tabValue;
              })[0];
              if (selectedTab) {
                const newTabeState = produce(selectedTab, (draft) => {
                  draft.display = true;
                });
                dispatch(editTab(newTabeState));
              }
            } else {
              const newElementState = produce(showElement, (draft) => {
                draft.properties.display = true;
              });
              dispatch(editElement(newElementState));
            }
          }
          return;
        case "hide":
          let hideElement = appState.elementList.present.filter((element) => {
            return element.id === action.renderComponent;
          })[0];
          if (hideElement) {
            if (
              (hideElement.type === "tab" || hideElement.type === "collaps") &&
              !action.entireElemet
            ) {
              let selectedTab = appState.tabList.filter((tab) => {
                return tab.id === action.tabValue;
              })[0];
              if (selectedTab) {
                const newTabeState = produce(selectedTab, (draft) => {
                  draft.display = false;
                });
                dispatch(editTab(newTabeState));
              }
            } else {
              const newElementState = produce(hideElement, (draft) => {
                draft.properties.display = false;
              });
              dispatch(editElement(newElementState));
            }
          }
          return;
        case "link-to-external":
          window.open(action.externalUrl, "_blank");
          return;
        case "enable-disable":
          let element = appState.elementList.present.filter((element) => {
            return element.id === action.renderComponent;
          })[0];
          if (element) {
            if (
              (element.type === "tab" || element.type === "collaps") &&
              !action.entireElemet
            ) {
              let selectedTab = appState.tabList.filter((tab) => {
                return tab.id === action.tabValue;
              })[0];
              if (selectedTab) {
                const newTabeState = produce(selectedTab, (draft) => {
                  draft.display = !draft.display;
                });
                dispatch(editTab(newTabeState));
              }
            } else {
              const newElementState = produce(element, (draft) => {
                draft.properties.disabled = !draft.properties.disabled;
              });
              dispatch(editElement(newElementState));
            }
          }
          return;
        default:
          return;
      }
    }
  };
};

export const startResetDropDownRuleForOtherValues = (action: ActionModel) => {
  return async (dispatch: Dispatch<AppActions>, getState: () => AppState) => {
    console.log(action.action);
    const appState = getState();
    switch (action.action) {
      case "show":
        let showElement = appState.elementList.present.filter((element) => {
          return element.id === action.renderComponent;
        })[0];
        if (showElement) {
          if (
            (showElement.type === "tab" || showElement.type === "collaps") &&
            !action.entireElemet
          ) {
            let selectedTab = appState.tabList.filter((tab) => {
              return tab.id === action.tabValue;
            })[0];
            if (selectedTab) {
              const newTabeState = produce(selectedTab, (draft) => {
                draft.display = true;
              });
              dispatch(editTab(newTabeState));
            }
          } else {
            const newElementState = produce(showElement, (draft) => {
              draft.properties.display = true;
            });
            dispatch(editElement(newElementState));
          }
        }
        return;
      case "hide":
        let selectedElement = appState.elementList.present.filter((element) => {
          return element.id === action.renderComponent;
        })[0];
        if (selectedElement) {
          if (
            (selectedElement.type === "tab" ||
              selectedElement.type === "collaps") &&
            !action.entireElemet
          ) {
            let selectedTab = appState.tabList.filter((tab) => {
              return tab.id === action.tabValue;
            })[0];
            if (selectedTab) {
              const newTabeState = produce(selectedTab, (draft) => {
                draft.display = true;
              });
              dispatch(editTab(newTabeState));
            }
          } else {
            const newElementState = produce(selectedElement, (draft) => {
              draft.properties.display = true;
            });
            dispatch(editElement(newElementState));
          }
        }
        return;
      default:
        return;
    }
  };
};
